module.exports = __webpack_public_path__ + "static/img/2.11929b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/2.jpg
// module id = 57CY
// module chunks = 1